export default {
    intro: `Read the passage carefully and solve Quizcat's questions.<br/>
            When you're done, a tasty snack will be waiting!`,
    next: 'Next',
};
